import {Component, inject} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {PasswordModule} from 'primeng/password';
import {CardModule} from 'primeng/card';
import {AuthenticationService} from '../../../core/services/authentication/authentication.service';
import {ToastService} from '../../../core/services/toast.service';
import {FloatLabel} from 'primeng/floatlabel';
import {LoginRequestModel} from '../../../core/services/authentication/models/login-request-model';
import {Message} from 'primeng/message';
import {finalize} from 'rxjs';
import { UnitService } from '../../../core/services/unit/unit.service';

@Component({
  selector: 'app-login',
  imports: [
    CardModule,
    InputTextModule,
    FormsModule,
    PasswordModule,
    ButtonModule,
    ReactiveFormsModule,
    FloatLabel,
    Message
  ],

  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  login = {
    email: '',
    password: '',
  };

  public loginForm: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, Validators.required),
  });
  public isLoading: boolean = false;

  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthenticationService);
  private readonly _toastService = inject(ToastService);
  private readonly _unitService = inject(UnitService);

  public loginSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    const value = this.loginForm.value as LoginRequestModel;

    this._authService.login(value)
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe({
        next: async (response) => {
          if (response.success) {
            const email = response.value.email;
            const token = response.value.idToken;
            const userId = response.value.userId;

            sessionStorage.setItem('email', email);
            sessionStorage.setItem('authenticated', 'true');
            sessionStorage.setItem('token', token);
            sessionStorage.setItem('userId', userId.toString());


            this._unitService.getUnitByUserId(+userId)
              .subscribe({
                next: (response) => {
                  this._unitService.setSelectedUnit(response[0]);
                }
              });

            await this._router.navigate(['home']);
          }
        },
        error: (error) => {
          console.error('Login error:', error);
        }
      });
  }
}
